module.exports = __webpack_public_path__ + "assets/img/little-logo.421849a3.png";